import { useEffect } from 'react';

export function usePageMetadata(title: string, description: string, image?: string | null) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    const entries: Array<[string, string, string]> = [
      ['name', 'description', description],
      ['property', 'og:title', title],
      ['property', 'og:description', description],
      ['property', 'og:url', window.location.origin + window.location.pathname],
      ['property', 'og:type', 'website'],
      ['name', 'twitter:card', image ? 'summary_large_image' : 'summary'],
    ];
    if (image) entries.push(['property', 'og:image', new URL(image, window.location.origin).href]);
    const cleanup = entries.map(([attribute, key, content]) => {
      const existing = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
      const element = existing ?? document.createElement('meta');
      const previous = element.content;
      element.setAttribute(attribute, key);
      element.content = content;
      if (!existing) document.head.appendChild(element);
      return () => { if (existing) element.content = previous; else element.remove(); };
    });
    return () => { document.title = previousTitle; cleanup.forEach(fn => fn()); };
  }, [title, description, image]);
}
